// extracted by mini-css-extract-plugin
export var downArrow = "_aa-0";
export var label = "_aa-1";
export var treatmentCard = "_aa-3";
export var upArrow = "_aa-2";